//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { PojoMap } from 'pojo-maps';

import * as mediaLibraryApi from '@apis/media-library/mediaLibraryApi';
import Cuid from '@models/Cuid';
import { IMlsMediaItem } from '@models/IMlsMediaItem';
import { createThunk } from '@redux/createThunk';
import { SliceNames } from '@redux/SliceNames';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IScheduleMediaState } from '@redux/schedule-media/scheduleMediaModel';

const initialState: IScheduleMediaState = {
  mediaItems: {},
};

const { actions, reducer } = createSlice({
  name: SliceNames.ScheduleMedia,
  initialState,
  reducers: {
    updateMediaItems(
      state,
      action: PayloadAction<PojoMap<Cuid, IMlsMediaItem>>,
    ) {
      state.mediaItems = PojoMap.union(state.mediaItems, action.payload);
    },
  },
});

export const { updateMediaItems } = actions;

export const getMediaItemsByCuid = createThunk(
  (cuids: Cuid[]) => async (dispatch) => {
    const mediaItemRecord: PojoMap<
      Cuid,
      IMlsMediaItem
    > = await mediaLibraryApi.getMediaItemsByCuid(cuids);
    dispatch(updateMediaItems(mediaItemRecord));
    return mediaItemRecord;
  },
);

export const getMediaItemByCuid = createThunk(
  (cuid: Cuid) => async (dispatch) => {
    const mediaItemRecord: PojoMap<
      Cuid,
      IMlsMediaItem
    > = await mediaLibraryApi.getMediaItemsByCuid([cuid]);
    dispatch(updateMediaItems(mediaItemRecord));
    return PojoMap.get(mediaItemRecord, cuid);
  },
);

export default reducer;
